module.exports = __webpack_public_path__ + "img/98.338662e2.jpg";